import { get } from "lodash";
import { Fragment, useState } from "react";
import { Grid } from "@mui/material";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";

import { ComponentHeader, FileUpload } from "../../../components";
import { uploadToS3 } from "../../../utils";
import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import {
  CancelButton,
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";

export default function FormFour({ formikProps, editState }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const [uploadAgreement, setUploadAgreement] = useState(
    !formikProps.values.agreement ? true : false
  );
  const [loading, setLoading] = useState(false);

  function handleChange({ target }) {
    const file = get(target, "files[0]", "");
    let fileName = file?.name?.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, "");
    let folderPath = "public/agreements/" + new Date().getTime() + "_";
    const uploadBucket = {
      name: process.env.REACT_APP_S3_BUCKET_NAME,
      region: process.env.REACT_APP_S3_BUCKET_REGION,
      identityPoolID: "ap-south-1:e58786e7-9711-4dea-a2e2-7d9c10e38333",
    };

    uploadToS3({
      bucket: uploadBucket,
      filePath: folderPath + fileName,
      file,
    }).then((response) => {
      if (response.status) {
        formikProps.setFieldValue(
          "agreement",
          "https://" +
            uploadBucket.name +
            ".s3.ap-south-1.amazonaws.com/" +
            folderPath +
            fileName
        );
      }
    });
  }

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader
          title={"Upload Agreement"}
          buttons={[
            uploadAgreement &&
              (formikProps.values.is_brand_verified === 0 ||
                formikProps.values.is_agency_verified === 0) && (
                <CancelButton
                  variant="outlined"
                  onClick={() => setUploadAgreement(!uploadAgreement)}
                >
                  Cancel
                </CancelButton>
              ),
            !uploadAgreement &&
              (formikProps.values.is_brand_verified === 0 ||
                formikProps.values.is_agency_verified === 0) && (
                <PrimaryButton
                  variant="contained"
                  onClick={() => setUploadAgreement(!uploadAgreement)}
                >
                  Upload New Agreement
                </PrimaryButton>
              ),
          ]}
        />
      </Grid>

      <Grid size={6}>
        <FileUpload
          onChange={handleChange}
          required
          disabled={!uploadAgreement}
          style={{ paddingTop: "24px" }}
          name="agreement"
          formikProps={formikProps}
          placeholder="Upload signed Agreement"
          allowedExtension=".pdf"
          value={formikProps.values?.agreement
            ?.split("/")
            .pop()
            .slice(
              formikProps.values?.agreement?.split("/").pop().indexOf("_") + 1
            )}
          previewIcon={formikProps.values?.agreement}
          folderPath={"public/agreements/" + new Date().getTime() + "_"}
        />
      </Grid>

      {uploadAgreement && (
        <Grid size={12} style={{ textAlign: "end" }}>
          <PrimaryLoadingButton
            variant="contained"
            loading={loading}
            disabled={!formikProps.values?.agreement}
            onClick={() => {
              setLoading(true);
              axios({
                url: "/admin/company/agreements/sign",
                method: "POST",
                disableRedirect: true,
                data: {
                  company_id: formikProps.values.ID,
                  agreement_url: formikProps.values?.agreement,
                },
              }).then((response) => {
                if (response.status) {
                  setUploadAgreement(false);
                  dispatch(
                    alert({
                      type: "success",
                      message: "Agreement Uploaded successfully",
                    })
                  );
                }
                setLoading(false);
              });
            }}
          >
            Upload Agreement
          </PrimaryLoadingButton>
        </Grid>
      )}
    </Fragment>
  );
}
